import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionnaireRespondentSessionMutation, deleteQuestionnaireRespondentSessionMutationVariables } from '../generated/deleteQuestionnaireRespondentSessionMutation';
import { questionnaireRespondentSessionFieldsFragment } from '../models/QuestionnaireRespondentSession';

/**
 * Get a callback to delete a QuestionnaireRespondentSession in the store.
 */
export function useDeleteQuestionnaireRespondentSessionCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionnaireRespondentSessionMutation, deleteQuestionnaireRespondentSessionMutationVariables>(
        gql`
            mutation deleteQuestionnaireRespondentSessionMutation ($id: ID!) {
                deleteQuestionnaireRespondentSession(id: $id) {
                    ...questionnaireRespondentSessionFields
                }
            }

            ${questionnaireRespondentSessionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
